import { render } from "./app_dashboard.vue?vue&type=template&id=043661ac&scoped=true"
import script from "./app_dashboard.vue?vue&type=script&lang=js"
export * from "./app_dashboard.vue?vue&type=script&lang=js"

import "./app_dashboard.vue?vue&type=style&index=0&id=043661ac&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043661ac"]])

export default __exports__